<h2 mat-dialog-title>{{ title ?? data.title | translate }}</h2>

<div mat-dialog-content>
  <ng-content></ng-content>
</div>

<div mat-dialog-actions>
  <ecu-button
    [color]="primaryButtonColor"
    [isDisabled]="isPrimaryButtonLoading || isPrimaryButtonDisabled"
    [isLoading]="isPrimaryButtonLoading"
    (click)="onPrimaryButtonClick($event)"
  >
    {{ primaryButtonLabel | translate }}
  </ecu-button>
  <ecu-button (click)="onSecondaryButtonClick($event)">
    {{ secondaryButtonLabel | translate }}
  </ecu-button>
</div>
